// extracted by mini-css-extract-plugin
export var avatarContainer = "_aw-0";
export var avatarTypingWave = "_aw-i";
export var gray = "_aw-f";
export var green = "_aw-c";
export var icon = "_aw-9";
export var image = "_aw-1";
export var lg = "_aw-6";
export var md = "_aw-5";
export var presenceDot = "_aw-b";
export var red = "_aw-d";
export var sm = "_aw-4";
export var status = "_aw-a";
export var typingDot = "_aw-h";
export var typingPill = "_aw-g";
export var xl = "_aw-7";
export var xs = "_aw-3";
export var xxl = "_aw-8";
export var xxs = "_aw-2";
export var yellow = "_aw-e";